import React from 'react';

export const SmsOptInContext = React.createContext<null>(null);
